import { render, staticRenderFns } from "./mGameBetting.vue?vue&type=template&id=7b8deba3&scoped=true"
import script from "./mGameBetting.vue?vue&type=script&lang=js"
export * from "./mGameBetting.vue?vue&type=script&lang=js"
import style0 from "./mGameBetting.vue?vue&type=style&index=0&id=7b8deba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8deba3",
  null
  
)

export default component.exports